const formatFileTypes = (types) => {
  return types?.map((type) => `${type.toLowerCase()}`).join(', ') || '';
};

export default formatFileTypes;
